/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Badge_Community_HintInputs */

const en_pb_badge_community_hint = /** @type {(inputs: Pb_Badge_Community_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared by the community on GitHub — not reviewed by Bystep. Read it before you use it.`)
};

const id_pb_badge_community_hint = /** @type {(inputs: Pb_Badge_Community_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibagikan komunitas lewat GitHub — tidak ditinjau Bystep. Baca dulu sebelum dipakai.`)
};

/**
* | output |
* | --- |
* | "Shared by the community on GitHub — not reviewed by Bystep. Read it before you use it." |
*
* @param {Pb_Badge_Community_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_badge_community_hint = /** @type {((inputs?: Pb_Badge_Community_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Badge_Community_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_badge_community_hint(inputs)
	return en_pb_badge_community_hint(inputs)
});